import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-revolution-slider1',
  templateUrl: './revolution-slider1.component.html'
})
export class RevolutionSlider1Component implements OnInit {
  imgSrc = './assets/revslider/assets';
  constructor() { }

  ngOnInit() {
  }

}
